module.exports = __webpack_public_path__ + "img/insight.a65aecc.jpg";